// extracted by mini-css-extract-plugin
module.exports = {"btn":"smallButton_btn__1IAPG","btnDis":"smallButton_btnDis__lv6WB","btnNotActive":"smallButton_btnNotActive__19D0p","fadeIn":"smallButton_fadeIn__25ulh"};